<!-- Render the currently active route -->
<router-outlet></router-outlet>
